import request from '@/lib/request/';

const baseUri = '/trend';

/**
 * トレンドグラフ用時系列データ取得
 * @param {Object} params
 * @param {string} params.kurama - KURAMA 端末 ID
 * @param {string} params.mesh - メッシュコード
 * @param {string} params.from - 'YYYY-MM-DD HH:MM'
 * @param {string} params.to - 'YYYY-MM-DD HH:MM'
 * @returns {Promise}
 */
export function get(params) {
  return request({
    url: baseUri,
    method: 'get',
    params,
  });
}
